<template>
  <div class="c-paginator">
    <p 
      v-if="total" class="c-paginator__label"
      :style="{fontSize: innerWidth <= 744 && totalFontSizeSP + 'px'}"
    >
      <span class="c-paginator__label--total content_total">
        <span 
          class="c-paginator__label--num content_total_num"
          :style="{
            fontSize: innerWidth <= 744 && totalNumFontSizeSP + 'px !important'
          }"
        >
          {{ total }}</span
        >件中</span
      >{{ (currentPage - 1) * size_ + 1 }}～{{ total > currentPage * size_ ? currentPage * size_ : total }}件表示
    </p>
    <p 
      v-else 
      class="c-paginator__label"
      :style="{fontSize: innerWidth <= 744 && totalFontSizeSP + 'px'}"
    >
      <span class="c-paginator__label--total">
        <span 
          class="c-paginator__label--num content_total_num"
          :style="{fontSize: innerWidth <= 744 && totalNumFontSizeSP + 'px'}"
        >
          0
        </span>
        件中
      </span>
      0件表示
    </p>

    <div v-if="this.total > 10 && paginatorAvailable" class="c-paginator__wrap">
      <a
        class="c-paginator__button c-paginator__button--left"
        :class="{ 'is-disable': currentPage == 1 }"
        @click="pageChange(1, currentPage == 1)"
        ><Icon name="arrow_first_page"
      /></a>
      <a
        class="c-paginator__button c-paginator__button--left"
        :class="{ 'is-disable': currentPage == 1 }"
        @click="pageChange(currentPage - 1, currentPage == 1)"
        ><Icon name="arrow_left"
      /></a>

      <div class="c-paginator__inner">
        <!-- PCレイアウト時 -->
        <ul class="c-paginator__list c-paginator__list--PC">
          <li
            v-for="page in pageRange(false)"
            :key="page"
            class="c-paginator__item"
            :class="isCurrent(page) ? 'is-current' : ''"
            @click="pageChange(page)"
          >
            {{ page }}
          </li>
        </ul>
        <!-- SPレイアウト時 -->
        <ul class="c-paginator__list c-paginator__list--SP">
          <li
            v-for="page in pageRange(true)"
            :key="page"
            class="c-paginator__item"
            :class="isCurrent(page) ? 'is-current' : ''"
            @click="pageChange(page)"
          >
            {{ page }}
          </li>
        </ul>
      </div>
      <a
        class="c-paginator__button c-paginator__button--right"
        :class="{ 'is-disable': currentPage == lastPage }"
        @click="pageChange(currentPage + 1, currentPage == lastPage)"
        ><Icon name="arrow_right"
      /></a>
      <a
        class="c-paginator__button c-paginator__button--right"
        :class="{ 'is-disable': currentPage == lastPage }"
        @click="pageChange(lastPage, currentPage == lastPage)"
        ><Icon name="arrow_last_page"
      /></a>
    </div>
    <!-- /.c-paginator__wrap -->

    <div v-if="isSort" class="c-paginator__sort">
      <Icon
        class="c-paginator__sort__icon"
        name="action_sort"
        width="20px"
        height="20px"
      />
      <FormsSelect :value="selected" @change="$emit('changeSort')">
        <option v-for="(item, i) in sortList" :key="i" :value="item.value">
          {{ item.label }}</option
        >
      </FormsSelect>
    </div>
    <!-- /.c-paginator__sort -->
  </div>
  <!-- /.c-paginator -->
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      required: false
    },
    total: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: false
    },
    isSort: {
      type: Boolean,
      default: false
    },
    sortList: {
      type: Array,
      default: () => []
    },
    /**
     * フォントサイズ：「xx件中yy〜zz件表示」
     * 初期値：14
     */
    totalFontSizeSP: {
      type: Number,
      default: 14
    },
    /**
     * フォントサイズ：合計件数
     * 初期値：16
     */
    totalNumFontSizeSP: {
      type: Number,
      default: 16
    },
    /**
     * ページネーションを表示する
     * 初期値：true
     */
    paginatorAvailable: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    range: 4,
    selected: null,
    innerWidth: window.innerWidth
  }),
  computed: {
    size_() {
      return this.size || this.$config.pageSize;
    },
    pagination() {
      return [...Array(Math.ceil(this.total / this.size_)).keys()].map(
        (n) => n + 1
      );
    },
    currentPage() {
      if (!this.$route.query || !this.$route.query.page) return 1;
      return parseInt(this.$route.query.page);
    },
    lastPage() {
      return this.pagination[this.pagination.length - 1];
    },
    pageRange() {
      let self = this;
      return function(isSmartPhone) {
        let start = "";
        let end = "";

        if (self.currentPage < self.range) {
          start = 1;
          end = self.range + 1;
        } else if (self.currentPage > self.lastPage - self.range + 1) {
          start = self.lastPage - self.range;
          end = self.lastPage;
        } else {
          start = self.currentPage - Math.floor(self.range / 2);
          end = self.currentPage + Math.floor(self.range / 2);
        }
        if (self.lastPage <= self.range + 1) {
          start = 1;
          end = self.lastPage;
        }
        if (!isSmartPhone) return self.calRange(start, end);
        return [self.currentPage];
      };
    },
    sortValue() {
      let query = Object.assign({}, this.$route.query);
      if (!query.sort) return this.sortList[0];
      return query.sort;
    }
  },
  mounted() {
    if (this.sortValue) this.selected = this.sortValue;
  },
  methods: {
    pageChange(page, disabled = false) {
      if (disabled) return false;
      let query = Object.assign({}, this.$route.query);
      this.$router.push({ query: { ...query, page } });
      this.$emit("pageChange", page);
    },
    isCurrent(page) {
      return page === this.currentPage;
    },
    calRange(start, end) {
      const range = [];
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      return range;
    }
  },
  watch: {
    $route() {
      this.selected = this.sortValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.content_total {
  margin-right: 0 !important;
  font-weight: bold;
}
</style>
